import { Component, OnInit } from '@angular/core';
import { AppCmsUrlsInitializationService } from '../../services/app-cms-urls-initialization.service';
import { ApplicationInitializationService } from '../../services/application-initialization.service';
import { UtilitiesService } from '../../utilities/utilities.service';
import { CmsContentService } from '../../services/cms-content.service';

@Component({
  selector: 'app-autopay-cms',
  templateUrl: './autopay-cms.component.html',
  styleUrls: ['./autopay-cms.component.scss']
})
export class AutopayCmsComponent implements OnInit {

  data: any;
  cmsUrlCode: any;

  constructor( private APPCMSIS: AppCmsUrlsInitializationService,
    private UTS: UtilitiesService,
    private APPIS: ApplicationInitializationService,
    private CCS:CmsContentService,) { }

  ngOnInit(): void {
    this.init();
  }

  init(){
    this.cmsUrlCode = 'SETUP_AUTOPAY_CMS_URL_ADDONS';
    let CMS_URLS = this.APPCMSIS.appInitializer.CMS_URLS;
    let CMS_URL = null;
    let url = null;
    if (CMS_URLS && CMS_URLS.length > 0){
      CMS_URL = CMS_URLS.find((c) => c?.cmsUrlCode == this.cmsUrlCode);
     url =
      this.APPIS.environmentConfig.CMS_URL_NEW_FRAGMENTPATH + CMS_URL?.cmsUrlEn;
    }
    if (this.UTS.getLocaleLanguage() == 'ar')
      url =
        this.APPIS.environmentConfig.CMS_URL_NEW_FRAGMENTPATH +
        CMS_URL?.cmsUrlAr;
      this.CCS.newFragemnetContentService(url).subscribe(
        (result: any) => {
        console.log("data:",result)
        this.data = result?.data?.bauMainSectionByPath?.item;
        console.log("data:",this.data)
      },
      (error) => {
      }
    );
  }

}
